import React, { cloneElement, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import sortBy from 'lodash/sortBy';
import { Draggable } from 'react-beautiful-dnd';
import TreeNode from '../tree/TreeNode';
import SubGroup from './SubGroup';
import TableContext from '../../TableContext';
const SubGroups = function SubGroups(props) {
    const { treeNodeRenderer, treeNodeSuffix, records, onDragEnd, ...rest } = props;
    const { tableStore: { columnDraggable } } = useContext(TableContext);
    return (React.createElement(React.Fragment, null, sortBy(records, [r => r.get('sort')]).map((record, index, list) => {
        const children = (record.children ? (React.createElement(SubGroup, Object.assign({ key: record.key, record: record, childrenRecords: record.children, onDragEnd: onDragEnd, treeNodeRenderer: treeNodeRenderer, treeNodeSuffix: treeNodeSuffix, index: index, records: list }, rest))) : (React.createElement(TreeNode, Object.assign({ key: record.key, record: record, isLeaf: true, renderer: treeNodeRenderer, suffix: treeNodeSuffix, index: index, records: list }, rest))));
        return columnDraggable && record.get('draggable') !== false && (!record.parent || list.length > 1) ? (React.createElement(Draggable, { key: record.key, draggableId: String(record.key), index: index }, (provided, snapshot) => (cloneElement(children, { provided, snapshot })))) : children;
    })));
};
SubGroups.displayName = 'SubGroups';
export default observer(SubGroups);
